import { render } from "./ProductsCrowdsuranceChange.vue?vue&type=template&id=785e194b&scoped=true"
import script from "./ProductsCrowdsuranceChange.vue?vue&type=script&lang=js"
export * from "./ProductsCrowdsuranceChange.vue?vue&type=script&lang=js"

import "./ProductsCrowdsuranceChange.vue?vue&type=style&index=0&id=785e194b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785e194b"]])

export default __exports__